import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default class extends Controller {
  static values = {
    data: Object,
    label: String,
    type: { type: String, default: 'line' },
    color: { type: String, default: '#3b82f6' },
    useRawLabels: { type: Boolean, default: false }
  }

  connect() {
    const ctx = this.element.getContext('2d')
    
    // For raw labels (like hours), we keep the order from the Object keys (which we preserve in Ruby)
    // For date labels, we sort them to ensure timeline consistency
    let labels, values
    
    if (this.useRawLabelsValue) {
      labels = Object.keys(this.dataValue)
      values = labels.map(label => this.dataValue[label])
    } else {
      labels = Object.keys(this.dataValue).sort()
      values = labels.map(label => this.dataValue[label])
    }

    if (labels.length === 0) {
      // Optional: Handle empty data state
      ctx.font = "12px Inter"
      ctx.fillStyle = "#94a3b8"
      ctx.textAlign = "center"
      ctx.fillText("No data available for this period", this.element.width / 2, this.element.height / 2)
      return
    }

    const formattedLabels = this.useRawLabelsValue 
      ? labels 
      : labels.map(l => new Date(l).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }))

    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: {
        labels: formattedLabels,
        datasets: [{
          label: this.labelValue,
          data: values,
          borderColor: this.colorValue,
          backgroundColor: this.colorValue + '20', // Transparent version
          borderWidth: 3,
          fill: true,
          tension: 0.4,
          pointRadius: 4,
          pointBackgroundColor: '#fff',
          pointBorderColor: this.colorValue,
          pointBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            mode: 'index',
            intersect: false,
            backgroundColor: '#0f172a',
            titleFont: { weight: 'bold' },
            padding: 12,
            cornerRadius: 12,
            displayColors: false
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { size: 10, weight: 'bold' }, color: '#94a3b8' }
          },
          y: {
            grid: { color: '#f1f5f9' },
            ticks: { font: { size: 10, weight: 'bold' }, color: '#94a3b8' },
            beginAtZero: true
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
